import React from "react";

export default function Sitemap() {
  return (
    <footer className="flex text-center px-4 py-8 justify-center">
      <p className="text-sm">
        Copyright{" "}
        {new Date(process.env.REACT_APP_SITE_START_TIMESTAMP).getFullYear()} •
        All Rights Reserved LuxSpace by BuildWith Angga
      </p>
    </footer>
  );
}
